export const projects = [
    {
        title: "Chomp",
        subtitle: "JavaScript",
        description: "Famous mathematical game that me and an undergrad wrote an AI for.",
        image: "chomp.png",
        link: "https://www.matthewrjust.com/chomp.html", //optional
    },
    {
        title: "Primality Tester",
        subtitle: "JavaScript",
        description: "Program to determine whether or not a positive integer is prime.",
        image: "primes.png",
        link: "https://www.matthewrjust.com/primes.html",
    },
];



// WEBPACK FOOTER //
// ./src/data/projects.js